module.exports = __webpack_public_path__ + "media/images/gallery/constellations/uv-0f2a140e4a52e12f036768f45c544b78.jpg";